// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/manifest.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { ServiceDefinition, ServiceDefinitionJson } from "./service_definition_pb";
import { file_mochabugapis_adapt_plugins_v1_service_definition } from "./service_definition_pb";
import type { StateContract, StateContractJson } from "./state_contract_pb";
import { file_mochabugapis_adapt_plugins_v1_state_contract } from "./state_contract_pb";
import type { Vertex, VertexJson } from "./vertex_pb";
import { file_mochabugapis_adapt_plugins_v1_vertex } from "./vertex_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/manifest.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_manifest: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_mochabugapis_adapt_plugins_v1_service_definition, file_mochabugapis_adapt_plugins_v1_state_contract, file_mochabugapis_adapt_plugins_v1_vertex]);

/**
 * Manifest describes a plugin and its properties.
 *
 * ## Architecture Overview
 *
 * A plugin consists of:
 * 1. **Vertices**: The actual workflow nodes that users add to automation graphs
 * 2. **Service Definitions**: Flat declarations of services (OAuth2, HTTP Proxy, Variables, Groups, OneOf)
 * 3. **System Services**: String array referencing service definitions used at the plugin level
 *
 * ## Service Architecture
 *
 * **Service definitions are ALWAYS flat** - they exist at the top level of the manifest
 * and are never nested within each other. This includes:
 * - Oauth2Definition
 * - HttpProxyDefinition
 * - VariableDefinition
 * - GroupedDefinition (references other flat definitions)
 * - OneOfDefinition (references other flat definitions)
 *
 * **Services are referenced by name as strings**. Service lists are string arrays where each
 * string must match a ServiceDefinition's `name`. Services exist at two levels:
 * - `system_services`: Plugin-level services configured once for the entire plugin
 * - `user_services` (in Vertex): Vertex-level services configured per vertex instance
 *
 * The `optional` field in ServiceDefinition controls whether a service must be configured:
 * - `optional: false` (default): User MUST configure this service
 * - `optional: true`: User MAY skip configuring this service
 *
 * ## Example Structure
 *
 * ```protobuf
 * Manifest {
 *   name: "stripe_plugin"
 *   version: "1.0.0"
 *
 *   // Flat service definitions at manifest level
 *   service_definitions: [
 *     { name: "stripe_oauth", oauth2: {...} },
 *     { name: "stripe_api", http_proxy: {...} },
 *     { name: "webhook_secret", variable: {...} }
 *   ]
 *
 *   // System-level services (plugin-wide)
 *   // Each string references a service definition name
 *   system_services: ["stripe_oauth"]
 *
 *   // Vertices with their own service references
 *   vertices: [
 *     {
 *       name: "CreatePayment",
 *       user_services: ["stripe_api", "webhook_secret"]
 *     }
 *   ]
 * }
 * ```
 *
 * ## Security Considerations
 *
 * The platform ensures that secrets and certificates are stored and transmitted securely.
 *
 * *** Plugin authors must also ensure that their implementations
 * handle sensitive data appropriately! ***
 *
 * @generated from message mochabugapis.adapt.plugins.v1.Manifest
 */
export type Manifest = Message<"mochabugapis.adapt.plugins.v1.Manifest"> & {
  /**
   * 'name' is the alpha-numeric identifier of the plugin. Must be conform to a ES variable name
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 'version' is the plugin's version, following SemVer 2.0: https://semver.org/
   *
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * 'label' is a human-friendly label displayed in the UI.
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * 'description' is a short, human-friendly description displayed in the UI.
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 'organization' is the id of the organization the user belongs to.
   *
   * @generated from field: string organization = 5;
   */
  organization: string;

  /**
   * 'homepage' is the plugin's homepage URL.
   *
   * @generated from field: optional string homepage = 6;
   */
  homepage?: string | undefined;

  /**
   * 'repository' is the plugin's repository URL.
   *
   * @generated from field: optional string repository = 7;
   */
  repository?: string | undefined;

  /**
   * 'bugs' is the URL or email for reporting bugs.
   *
   * @generated from field: optional string bugs = 8;
   */
  bugs?: string | undefined;

  /**
   * 'author' is the name of the plugin's author.
   *
   * @generated from field: optional string author = 9;
   */
  author?: string | undefined;

  /**
   * 'logo' is an optional path to the plugin logo.
   * The logo will be resized to a maximum of 80x80 pixels.
   * - Supported file formats:
   *   - GIF: .gif
   *   - JPEG: .jpg, .jpeg, .jfif, .pjpeg, .pjp
   *   - PNG: .png
   *   - SVG: .svg
   *   - WEBP: .webp
   *   - AVIF: .avif
   *
   * @generated from field: optional string logo = 10;
   */
  logo?: string | undefined;

  /**
   * 'vertices' is a list of vertices that constitute the plugin.
   * this is filled in automatically when configurating a project on the filesystem
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.Vertex vertices = 11;
   */
  vertices: Vertex[];

  /**
   * 'service_definitions' are flat service definitions that can be referenced by bindings.
   *
   * All service definitions exist at this top level - they are NEVER nested.
   * Definitions can be referenced by:
   * - system_services (plugin-level bindings)
   * - user_services in vertices (vertex-level bindings)
   *
   * Each definition has a unique name used for referencing in bindings.
   * Service types: OAuth2, HTTP Proxy, Variable, Group, OneOf.
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.ServiceDefinition service_definitions = 12;
   */
  serviceDefinitions: ServiceDefinition[];

  /**
   * 'system_services' are plugin-level services configured once for the entire plugin.
   *
   * System services are:
   * - Configured by plugin administrators (via PostPluginSettings API)
   * - Shared across all vertices in the plugin
   * - Required to be configured before the plugin can be used (status = ACTIVE), unless marked optional
   *
   * This is a string array where each string directly references a ServiceDefinition by its name.
   * Plugin code accesses these services using the referenced service name.
   *
   * The `optional` field in the ServiceDefinition controls whether configuration is required:
   * - If ServiceDefinition.optional = false (default): MUST be configured
   * - If ServiceDefinition.optional = true: MAY be skipped
   *
   * Example:
   *   service_definitions: [
   *     { name: "github_oauth", oauth2: {...} },
   *     { name: "analytics", oauth2: {...}, optional: true }
   *   ]
   *   system_services: ["github_oauth", "analytics"]
   *   Plugin code references: "github_oauth", "analytics"
   *
   * IMPORTANT: For OAuth2 CODE grant type services, the service definition name is used
   * for callback URL generation.
   *
   * @generated from field: repeated string system_services = 13;
   */
  systemServices: string[];

  /**
   * 'config_store_plugin' is the contract for the plugin-wide config store.
   * If unset, the platform uses generation "default".
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.StateContract config_store_plugin = 14;
   */
  configStorePlugin?: StateContract | undefined;
};

/**
 * Manifest describes a plugin and its properties.
 *
 * ## Architecture Overview
 *
 * A plugin consists of:
 * 1. **Vertices**: The actual workflow nodes that users add to automation graphs
 * 2. **Service Definitions**: Flat declarations of services (OAuth2, HTTP Proxy, Variables, Groups, OneOf)
 * 3. **System Services**: String array referencing service definitions used at the plugin level
 *
 * ## Service Architecture
 *
 * **Service definitions are ALWAYS flat** - they exist at the top level of the manifest
 * and are never nested within each other. This includes:
 * - Oauth2Definition
 * - HttpProxyDefinition
 * - VariableDefinition
 * - GroupedDefinition (references other flat definitions)
 * - OneOfDefinition (references other flat definitions)
 *
 * **Services are referenced by name as strings**. Service lists are string arrays where each
 * string must match a ServiceDefinition's `name`. Services exist at two levels:
 * - `system_services`: Plugin-level services configured once for the entire plugin
 * - `user_services` (in Vertex): Vertex-level services configured per vertex instance
 *
 * The `optional` field in ServiceDefinition controls whether a service must be configured:
 * - `optional: false` (default): User MUST configure this service
 * - `optional: true`: User MAY skip configuring this service
 *
 * ## Example Structure
 *
 * ```protobuf
 * Manifest {
 *   name: "stripe_plugin"
 *   version: "1.0.0"
 *
 *   // Flat service definitions at manifest level
 *   service_definitions: [
 *     { name: "stripe_oauth", oauth2: {...} },
 *     { name: "stripe_api", http_proxy: {...} },
 *     { name: "webhook_secret", variable: {...} }
 *   ]
 *
 *   // System-level services (plugin-wide)
 *   // Each string references a service definition name
 *   system_services: ["stripe_oauth"]
 *
 *   // Vertices with their own service references
 *   vertices: [
 *     {
 *       name: "CreatePayment",
 *       user_services: ["stripe_api", "webhook_secret"]
 *     }
 *   ]
 * }
 * ```
 *
 * ## Security Considerations
 *
 * The platform ensures that secrets and certificates are stored and transmitted securely.
 *
 * *** Plugin authors must also ensure that their implementations
 * handle sensitive data appropriately! ***
 *
 * @generated from message mochabugapis.adapt.plugins.v1.Manifest
 */
export type ManifestJson = {
  /**
   * 'name' is the alpha-numeric identifier of the plugin. Must be conform to a ES variable name
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * 'version' is the plugin's version, following SemVer 2.0: https://semver.org/
   *
   * @generated from field: string version = 2;
   */
  version?: string;

  /**
   * 'label' is a human-friendly label displayed in the UI.
   *
   * @generated from field: string label = 3;
   */
  label?: string;

  /**
   * 'description' is a short, human-friendly description displayed in the UI.
   *
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * 'organization' is the id of the organization the user belongs to.
   *
   * @generated from field: string organization = 5;
   */
  organization?: string;

  /**
   * 'homepage' is the plugin's homepage URL.
   *
   * @generated from field: optional string homepage = 6;
   */
  homepage?: string;

  /**
   * 'repository' is the plugin's repository URL.
   *
   * @generated from field: optional string repository = 7;
   */
  repository?: string;

  /**
   * 'bugs' is the URL or email for reporting bugs.
   *
   * @generated from field: optional string bugs = 8;
   */
  bugs?: string;

  /**
   * 'author' is the name of the plugin's author.
   *
   * @generated from field: optional string author = 9;
   */
  author?: string;

  /**
   * 'logo' is an optional path to the plugin logo.
   * The logo will be resized to a maximum of 80x80 pixels.
   * - Supported file formats:
   *   - GIF: .gif
   *   - JPEG: .jpg, .jpeg, .jfif, .pjpeg, .pjp
   *   - PNG: .png
   *   - SVG: .svg
   *   - WEBP: .webp
   *   - AVIF: .avif
   *
   * @generated from field: optional string logo = 10;
   */
  logo?: string;

  /**
   * 'vertices' is a list of vertices that constitute the plugin.
   * this is filled in automatically when configurating a project on the filesystem
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.Vertex vertices = 11;
   */
  vertices?: VertexJson[];

  /**
   * 'service_definitions' are flat service definitions that can be referenced by bindings.
   *
   * All service definitions exist at this top level - they are NEVER nested.
   * Definitions can be referenced by:
   * - system_services (plugin-level bindings)
   * - user_services in vertices (vertex-level bindings)
   *
   * Each definition has a unique name used for referencing in bindings.
   * Service types: OAuth2, HTTP Proxy, Variable, Group, OneOf.
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.ServiceDefinition service_definitions = 12;
   */
  serviceDefinitions?: ServiceDefinitionJson[];

  /**
   * 'system_services' are plugin-level services configured once for the entire plugin.
   *
   * System services are:
   * - Configured by plugin administrators (via PostPluginSettings API)
   * - Shared across all vertices in the plugin
   * - Required to be configured before the plugin can be used (status = ACTIVE), unless marked optional
   *
   * This is a string array where each string directly references a ServiceDefinition by its name.
   * Plugin code accesses these services using the referenced service name.
   *
   * The `optional` field in the ServiceDefinition controls whether configuration is required:
   * - If ServiceDefinition.optional = false (default): MUST be configured
   * - If ServiceDefinition.optional = true: MAY be skipped
   *
   * Example:
   *   service_definitions: [
   *     { name: "github_oauth", oauth2: {...} },
   *     { name: "analytics", oauth2: {...}, optional: true }
   *   ]
   *   system_services: ["github_oauth", "analytics"]
   *   Plugin code references: "github_oauth", "analytics"
   *
   * IMPORTANT: For OAuth2 CODE grant type services, the service definition name is used
   * for callback URL generation.
   *
   * @generated from field: repeated string system_services = 13;
   */
  systemServices?: string[];

  /**
   * 'config_store_plugin' is the contract for the plugin-wide config store.
   * If unset, the platform uses generation "default".
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.StateContract config_store_plugin = 14;
   */
  configStorePlugin?: StateContractJson;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.Manifest.
 * Use `create(ManifestSchema)` to create a new message.
 */
export const ManifestSchema: GenMessage<Manifest, {jsonType: ManifestJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_manifest, 0);

